import Title from '@picsart/growth-rc/Title';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import extractTextFromHTML from 'templates/utils/extractTextFromHTML';
import Carousel from './Carousel';
import ShowAll from './ShowAll';

import { dataTestIds } from './constants';
import { TemplateBannerCarouselProps } from './types';
import useStyles from './styles';

const BannerCarousel = ({ bannerItems, title, showAll }: TemplateBannerCarouselProps) => {
  const classes = useStyles();

  return (
    <HorizontalContainer
      className={classes.root}
      data-pulse-section-group="new-template-hub"
      dataTestId={dataTestIds.root}
    >
      <div className={classes.topWrapper} data-pulse-section={extractTextFromHTML(title.text)}>
        <Title {...title} />
        {showAll && <ShowAll {...showAll} bannerTitle={title.text} />}
      </div>
      <Carousel bannerItems={bannerItems} bannerTitle={title.text} />
    </HorizontalContainer>
  );
};

export default BannerCarousel;
